module.exports = __webpack_public_path__ + "static/media/back.4d3d0063.svg";